export default "__VITE_ASSET__QLOCYLIE__"